import type { Contact } from "../types";
import { ContactShow } from "../contacts/ContactShow";
import { ContactEdit } from "../contacts/ContactEdit";
import { ClientList } from "./ClientList";
import { getContactDisplayName } from "../contacts/contact-details";

export default {
  list: ClientList,
  show: ContactShow,
  edit: ContactEdit,
  recordRepresentation: (record: Contact) =>
    getContactDisplayName(record),
};
